
import { Button } from "@/components/ui/button";
import { Loader2, Trash2 } from "lucide-react";
import { GroupLeaderRequest } from "@/types/admin-requests";

interface DeleteActionProps {
  request: GroupLeaderRequest;
  processingId: string | null;
  onDelete: (request: GroupLeaderRequest) => Promise<void>;
}

export const DeleteAction = ({
  request,
  processingId,
  onDelete,
}: DeleteActionProps) => {
  const isProcessing = !!processingId;
  const isCurrentProcessing = processingId === request.id;

  return (
    <div className="flex justify-end">
      <Button
        variant="destructive"
        onClick={() => onDelete(request)}
        disabled={isProcessing}
      >
        {isCurrentProcessing ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Trash2 className="h-4 w-4 mr-2" />
        )}
        Ta bort
      </Button>
    </div>
  );
};
